export default {
  "professionalsData": [
    {"name": "Sin Referente", "email": "evaluacioneshumanamente@gmail.com"},
    {"name": "Dra. María Renée Gándara Ulloa", "email": "dramariareneegandara@clinicahumanamente.com"},
    {"name": "Dr. Emilio Quinto Barrera", "email": "emilioquinto@pararypensar.org"},
    {"name": "Dr. Edwin Raúl Higueros López", "email": "draulhigueros@gmail.com"},
    {"name": "Dr. Walter William Rinze Turton", "email": "drwalterrinze@gmail.com"},
    {"name": "Dr. René Vladímir López Ramírez", "email": "vladilora666@gmail.com"},
    {"name": "Dr. Rolando Lemus Rodas", "email": "rolando_lemus@yahoo.es"},
    {"name": "Dra. Andrea Morales", "email": "andre20mp@gmail.com"},
    {"name": "Dra. Isabel Oliveros", "email": "isabeloliverosr@gmail.com"},
    {"name": "Licda. Carmen Lucia Ramírez", "email": "calusantizo2@hotmail.com"},
    {"name": "Licda. Shirley Galindo", "email": "shirleymgalindo@gmail.com"},
    {"name": "Licda. Melannie Gabriela Estrada Arreaga", "email": "gabaa9@gmail.com"},
    {"name": "Dra. María Eliza López Rodríguez", "email": "dra.marielopezrodriguez@gmail.com"},
    {"name": "Dra. María Cristina Bolaños Víquez", "email": "mc.bolanosv20@gmail.com"},
    {"name": "Dra. Ingrid Estrada", "email": "draingridestrada@gmail.com"},
    {"name": "Dr. Carlos Martínez", "email": "crmartinez@ufm.edu"},
    {"name": "Licda. Mónica Galicia", "email": "monicagaliciaclinica@gmail.com"},
    {"name": "Licda. Nazrin Alloud", "email": "nasrinalloud@ufm.edu"},
    {"name": "Licda. Dulce López", "email": "dlopezrodriguez1105@gmail.com"}
  ]
};
